/**
 * embedAuth — extracts and provides an embed token from URL query params.
 *
 * When Thread is loaded in embed mode (`/embed/:projectId/:view?token=...`),
 * the token is stored in sessionStorage so API calls can attach it as a
 * Bearer authorization header.
 */

const EMBED_TOKEN_KEY = "thread-embed-token";

/**
 * Extract the `token` query param from the current URL and persist it
 * in sessionStorage. Call this once on embed page mount.
 */
export function initEmbedToken(): void {
  const params = new URLSearchParams(window.location.search);
  const token = params.get("token");
  if (token) {
    sessionStorage.setItem(EMBED_TOKEN_KEY, token);
  }
}

/**
 * Retrieve the embed token (if any). Returns `null` when not in embed mode
 * or if no token was provided.
 */
export function getEmbedToken(): string | null {
  return sessionStorage.getItem(EMBED_TOKEN_KEY);
}

/**
 * Clear the stored embed token (e.g. on unmount or navigation away).
 */
export function clearEmbedToken(): void {
  sessionStorage.removeItem(EMBED_TOKEN_KEY);
}
